interface ModuleSubscription {
  hasBuyerAccess: boolean;
  hasContractAccess: boolean;
  hasProjectAccess: boolean;
}

export const withoutBuyerModules = ({ hasBuyerAccess, hasContractAccess, hasProjectAccess }: ModuleSubscription) =>
  !hasBuyerAccess && !hasContractAccess && !hasProjectAccess;
